/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: branding-media-edit-view-asset-component.ts
 *
 * Created by kyang on 10/29/20.
 */

function BrandingMediaEditViewAssetController(
    this: JS5Object,
) {
    this.onIngestProgress = (progress: number) => {
        if (progress === null) {
            delete this.ingestPercent;
        } else {
            this.ingestPercent = Math.round(progress * 100);
        }
    };
}

angular
    .module('prism-ui.components.branding')
    .component('brandingMediaEditViewAsset', {
        templateUrl: 'components/branding/editView/components/media/editView/components/asset/branding-media-edit-view-asset-template.html',
        controller: BrandingMediaEditViewAssetController,
        bindings: {
            sectionName: '@',
            containerType: '@',
            assetType: '@',
            rootAsset: '<',
            asset: '<',
            availableAcceptProfiles: '<?',
        }
    });
